//GeneratorFlag:[NoChange]
import { Server } from '@/core/server'
export default class DeliveryDateTypeService
{
	constructor(){}

	server(config)
	{
		return new Server(config)
	}

	//GeneratorFlag:[DeliveryDateType.Create]
	async create(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/delivery-date-type/create', params || { });
	};

	//GeneratorFlag:[DeliveryDateType.Delete]
	async delete(deliveryDateTypeId, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		const params = {
			id:deliveryDateTypeId
		}
	
		return await _server.delete('/store/delivery-date-type/delete', {'params':params})
	};

	//GeneratorFlag:[DeliveryDateType.Detail]
	async detail(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/delivery-date-type/detail', {'params':params});
	};

	//GeneratorFlag:[DeliveryDateType.List]
	async list(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = false;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.get('/store/delivery-date-type/list', {'params':params});
	};

	//GeneratorFlag:[DeliveryDateType.Update]
	async update(params, config)
	{
		config = config || {};
		if (config.HSR == undefined) config.HSR = true;
		if (config.HER == undefined) config.HER = true;
	
		const _server = 
			this.server(config);
	
		return await _server.post('/store/delivery-date-type/update', params || { });
	};

//GeneratorFlag:[NewAction]
}